import { useEffect } from "react";
import { useSelector } from "react-redux";
// import { useNavigate } from "react-router-dom";
import { config } from "../../config/app";
// import { RouterName } from "../../router";
import { deviceStorage } from "../../utils/devicestorage";

const PrivateRouter = (props: any) => {
    // const navigate = useNavigate();
    const auth = useSelector((state: any) => state.Auth);
    useEffect(()=>{
        const token = deviceStorage[config.appStorage].getItem(config.appPackage+'_X_TOKEN');
        if(!token) {
            // navigate(RouterName.LOGIN)
            // navigate(RouterName.MAIN)
        }

    }, [])
    return auth && auth.token ? <>{props.children}</> : <></>
}

export default PrivateRouter
